import { useEffect, useRef } from "react";

function useScrollToTopOnMessage(messageKey) {
  const previousMessageRef = useRef("");

  useEffect(() => {
    if (!messageKey || previousMessageRef.current === messageKey) {
      previousMessageRef.current = messageKey || "";
      return;
    }

    previousMessageRef.current = messageKey;

    requestAnimationFrame(() => {
      const scrollTarget = document.querySelector(".app-scrollbar");

      if (scrollTarget?.scrollTo) {
        scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }, [messageKey]);
}

export default useScrollToTopOnMessage;
